import { ICON_TYPES } from '../constants';

export const LoaderSmall = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_77_13527)">
        <path
          d="M11.7504 11.7504C13.3776 10.1232 13.3776 7.48504 11.7504 5.85786C10.1232 4.23068 7.48505 4.23068 5.85787 5.85786C4.23068 7.48504 4.23068 10.1232 5.85787 11.7504C7.48505 13.3776 10.1232 13.3776 11.7504 11.7504Z"
          fill="#2C2A27"
        />
        <path
          opacity="0.4"
          d="M22.9463 7.15422C24.5735 5.52704 24.5735 2.88885 22.9463 1.26167C21.3191 -0.365515 18.6809 -0.365515 17.0537 1.26167C15.4265 2.88885 15.4265 5.52704 17.0537 7.15422C18.6809 8.78141 21.3191 8.78141 22.9463 7.15422Z"
          fill="#2C2A27"
        />
        <path
          opacity="0.4"
          d="M34.1421 11.7504C35.7693 10.1232 35.7693 7.48504 34.1421 5.85786C32.5149 4.23068 29.8767 4.23068 28.2496 5.85786C26.6224 7.48504 26.6224 10.1232 28.2496 11.7504C29.8767 13.3776 32.5149 13.3776 34.1421 11.7504Z"
          fill="#2C2A27"
        />
        <path
          opacity="0.4"
          d="M38.7383 22.9463C40.3655 21.3191 40.3655 18.6809 38.7383 17.0537C37.1112 15.4265 34.473 15.4265 32.8458 17.0537C31.2186 18.6809 31.2186 21.3191 32.8458 22.9463C34.473 24.5735 37.1112 24.5735 38.7383 22.9463Z"
          fill="#2C2A27"
        />
        <path
          opacity="0.4"
          d="M34.1421 34.1421C35.7693 32.515 35.7693 29.8768 34.1421 28.2496C32.5149 26.6224 29.8767 26.6224 28.2496 28.2496C26.6224 29.8768 26.6224 32.515 28.2496 34.1421C29.8767 35.7693 32.5149 35.7693 34.1421 34.1421Z"
          fill="#2C2A27"
        />
        <path
          opacity="0.4"
          d="M22.9463 38.7383C24.5735 37.1111 24.5735 34.473 22.9463 32.8458C21.3191 31.2186 18.6809 31.2186 17.0537 32.8458C15.4265 34.473 15.4265 37.1111 17.0537 38.7383C18.6809 40.3655 21.3191 40.3655 22.9463 38.7383Z"
          fill="#2C2A27"
        />
        <path
          opacity="0.6"
          d="M11.7504 34.1421C13.3776 32.515 13.3776 29.8768 11.7504 28.2496C10.1232 26.6224 7.48505 26.6224 5.85787 28.2496C4.23068 29.8768 4.23068 32.515 5.85787 34.1421C7.48505 35.7693 10.1232 35.7693 11.7504 34.1421Z"
          fill="#2C2A27"
        />
        <path
          opacity="0.8"
          d="M7.15423 22.9463C8.78142 21.3191 8.78142 18.6809 7.15423 17.0537C5.52705 15.4265 2.88886 15.4265 1.26168 17.0537C-0.365507 18.6809 -0.365507 21.3191 1.26168 22.9463C2.88886 24.5735 5.52705 24.5735 7.15423 22.9463Z"
          fill="#2C2A27"
        />
      </g>
      <defs>
        <clipPath id="clip0_77_13527">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

LoaderSmall.iconType = ICON_TYPES.LOADER_SMALL;
